import { AuthService } from "./../../shared/models/auth.service";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { ErrorEscalationModel } from "./errorescalation.model";
import { JQueryHelperService } from "../../shared/models/jquery-helper.service";

@Injectable()
export class ErrorEscalationService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) {}

  public GetErrorEscalationConfigList(
    errorEscalationModel: ErrorEscalationModel,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getErrorEscalationConfigUrl = WeGoConfig.API_GET_ErrorEscalation_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getErrorEscalationConfigUrl =
        getErrorEscalationConfigUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getErrorEscalationConfigUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteErrorEscalation(
    errorEscalationHashID: string
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let url =
      WeGoConfig.API_GET_DELETE_ERRORESCALATION +
      "?errorEscalationHashID=" +
      errorEscalationHashID;
    return this.http
      .get(
        WeGoConfig.API_GET_DELETE_ERRORESCALATION +
          "?errorEscalationHashID=" +
          errorEscalationHashID,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetErrorEscalationByHashId(
    errorEscalationHashId: string
  ): Observable<IAPIResponse> {
    let getRoleUrl =
      WeGoConfig.API_GET_ERRORESCALATION_BY_HASH +
      "?errorEsclationHashID=" +
      errorEscalationHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getRoleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateErrorEscalation(
    errorEscalationModel: ErrorEscalationModel
  ): Observable<IAPIResponse> {
    let body = errorEscalationModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_ERRORESCALATION_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportErrorEscalation(
    errorEscalationLogModel: ErrorEscalationModel,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let exportErrorEscalationUrl = WeGoConfig.API_GET_EXPORT_ErrorEscalation;
    let queryString =
      this.authService.HandleAPIListInput(input) +
      "&" +
      this.JQueryHelper.Param(errorEscalationLogModel);
    if (queryString) {
      exportErrorEscalationUrl = exportErrorEscalationUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(exportErrorEscalationUrl, options);
  }

  public GetErrorEsclationDropdownList(
    isWegoAdmin: boolean = false 
  ): Observable<IAPIResponse> {
    let getErrorEsclationDropdownUrl =
      WeGoConfig.API_GET_DROPDOWN_ERRORESCLATION_LIST +
      "?isWegoAdmin=" +
      isWegoAdmin;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getErrorEsclationDropdownUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetInstanceAdminByInstance(instancaeHashId: string) {
    let getInstanceAdminByInstanceUrl =
      WeGoConfig.API_GET_INSTANCEADMINLISTBYINSTANCE_LIST +
      "?instanceHashId=" +
      instancaeHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceAdminByInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCustomerAdminByCustomer(customerHashId: string) {
    let getCustomerAdminByCustomerUrl =
      WeGoConfig.API_GET_CUSTOMERADMINLISTBYCUSTOMER_LIST +
      "?customerHashId=" +
      customerHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCustomerAdminByCustomerUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/errorescalation-configuration/models/errorescalation.service.ts